export const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL;
export const LOCATION_SUGGEST_ENDPOINT = process.env.REACT_APP_LOCATION_SUGGEST_ENDPOINT;
export const NEW_RELIC_LICENCE_KEY = process.env.REACT_APP_NEW_RELIC_BROWSER_LICENCE_KEY;
export const NEW_RELIC_APPLICATION_ID = process.env.REACT_APP_NEW_RELIC_BROWSER_APPLICATION_ID;
export const NEW_RELIC_ACCOUNT_ID = process.env.REACT_APP_NEW_RELIC_ACCOUNT_ID;
export const NEW_RELIC_TRUST_KEY = process.env.REACT_APP_NEW_RELIC_TRUST_KEY;
export const NEW_RELIC_AGENT_ID = process.env.REACT_APP_NEW_RELIC_AGENT_ID;
export const NEW_RELIC_DISTRIBUTED_TRACING_ENABLED = process.env.REACT_APP_NEW_RELIC_DISTRIBUTED_TRACING_ENABLED;
export const TEALIUM_UTAG_URL = process.env.REACT_APP_TEALIUM_UTAG_URL;
